/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './begin.defs.js'
export * as $defs from './begin.defs.js'
